export default __webpack_public_path__ + "static/office-cover-60-1bcfa04448451670ef47aa509b6d3d56.jpg";